import {ItemOptionWrapper, OptionsButtonContainer, OptionsButtonOptionWrapper} from "./OptionsButton.styled";
import DotsIcon from '@mui/icons-material/MoreVert';
import {observer} from "mobx-react";
import React, {useCallback, useState} from "react";
import {useStore} from "../../../../../../../hooks";
import {MarketingStatus} from "../../../../../../../utils/enums";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import { useUserCheckPermissions } from "../../../../../../../hooks/useUserCheckPermissions";
import {PermissionCodes} from "../../../../../../../utils/enums";

export const OptionsButton = observer(({ conversation, type }) => {
  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const { marketingStore } = useStore();
  const { checkPermission, warningMessageTitle, showAlert, closeAlert } = useUserCheckPermissions();

  if (type === "trigger") {
    return <></>;
  }

  const onHandleDuplicated = useCallback(() => {
    void marketingStore.cloneCampaign(conversation);
  }, [conversation, marketingStore]);

  const onHandleCancelled = useCallback(() => {
    void marketingStore.cancelCampaign(conversation);
  }, [conversation, marketingStore]);

  const onHandleArchived = useCallback(() => {
    void marketingStore.deleteCampaign(conversation);
  }, [conversation, marketingStore]);

  const onHandleChangeMode = useCallback((mode) => {
    void marketingStore.changeModeCampaign(conversation, mode);
  }, [conversation, marketingStore]);

  const onToggleOptions = () => {
    setIsOpenOptions(!isOpenOptions);
  };

  return (
    <>
      <OptionsButtonContainer data-testid="options-button" onClick={() => onToggleOptions()}>
        <DotsIcon sx={{ fontSize: 15 }} />
        <OptionsButtonOptionWrapper visible={isOpenOptions.toString()}>
          {checkPermission(PermissionCodes.DUPLICATE_CAMPAIGNS, "CREATE") && (
              <ItemOptionWrapper onClick={() => onHandleDuplicated()}>Duplicate campaign</ItemOptionWrapper>
          )}
          {conversation.status !== MarketingStatus.DRAFT && <ItemOptionWrapper onClick={() => onHandleCancelled()}>Cancel campaign</ItemOptionWrapper>}
          {conversation.status === MarketingStatus.DRAFT && checkPermission(PermissionCodes.ARCHIVE_CAMPAIGNS, "UPDATE") && <ItemOptionWrapper onClick={() => onHandleArchived()}>Archive campaign</ItemOptionWrapper>}
          {conversation.status === MarketingStatus.MANUAL && <ItemOptionWrapper onClick={() => onHandleChangeMode('auto')}>Change to Automated reply</ItemOptionWrapper>}
          {conversation.status === MarketingStatus.RUNNING && <ItemOptionWrapper onClick={() => onHandleChangeMode('manual')}>Change to Manual reply</ItemOptionWrapper>}
        </OptionsButtonOptionWrapper>
      </OptionsButtonContainer>
      {showAlert && (
        <Alerts severity="warning" message={warningMessageTitle} onClose={closeAlert}/>
      )}
    </>
  );
});
